export const PO_REQUESTS_COMBOS_IDS = ['tipo_mercado_campañas', 'cnae']
